var _style, _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line10, _path8, _path9, _polygon, _polygon2, _circle, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCutbelt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 423 520",
    style: {
      enableBackground: "new 0 0 423 520"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st392{fill:#FFFFFF;}\n\t.st391{fill:#FFFFFF;stroke:#000000;stroke-width:3.47;stroke-miterlimit:10;}\n\t.st390{fill:#FFFFFF;stroke:#000000;stroke-width:1.16;stroke-miterlimit:10;}\n\t.st389{fill:#FFFFFF;stroke:#000000;stroke-width:0.51;stroke-miterlimit:10;stroke-dasharray:1.52;}\n\t.st388{fill:#FFFFFF;stroke:#010101;stroke-width:3.12;stroke-miterlimit:10;}\n\t.st387{fill:none;stroke:#000000;stroke-width:3.47;stroke-miterlimit:10;}\n\t.st386{fill:none;}\n\t.st385{fill:none;stroke:#000000;stroke-width:0.51;stroke-miterlimit:10;}\n\t.st384{fill:none;stroke:#000000;stroke-width:0.51;stroke-miterlimit:10;stroke-dasharray:1.56,1.56;}\n\t.st383{fill:#FFFFFF;stroke:#000000;stroke-width:3.73;stroke-miterlimit:10;}\n\t.st382{fill:#FFFFFF;stroke:#000000;stroke-width:3.41;stroke-miterlimit:10;}\n\t.st381{fill:#FFFFFF;stroke:#000000;stroke-width:1.18;stroke-miterlimit:10;}\n")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 204.6,
    y: 325.1,
    className: "st392",
    width: 154.4,
    height: 27.7
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st391",
    d: "M60.7,348.6v-13.8c0.7-9.6,1.5-19.4,2.6-29.4c2.4-24,5.3-46,8.4-65.2c0.2-1.5,0.5-3.1,0.7-4.6 c2.6-15.9,5.1-29.8,7.4-41.5V194c8.1,2.1,19,4.6,31.9,6.7c2.9,0.5,10.3,1.7,20.9,2.9l-0.2,9.3l10.8,0.2l0.2-8.5 c4.3,0.4,8.9,0.7,13.8,1c1.5,0.1,3,0.2,4.6,0.2l4.1,0.2c14.5,0.6,27.8,0.3,38.9,0.1c1.9,0,3.9-0.1,6.1-0.1v27.2 c-0.2,40.2-0.3,80.3-0.5,120.4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st391",
    d: "M211,206.1v0.2l-0.1,14.8v0.4c0,3.9,0,7.9-0.1,11.8v-27.2H211z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st391",
    d: "M211.4,333.2L211.4,333.2c0.9,0,1.8,0.1,2.7,0.1c14.2,0.1,26.1-10.7,27.4-24.8V206.4c5.6,0,11.5-0.1,17.6-0.3 c1.5,0,3-0.1,4.6-0.2c5.5-0.2,11.2-0.6,17.2-1.1l0.2,8.5l10.8-0.2l-0.2-9.3c6.7-0.8,13.7-1.7,20.9-2.9c11.9-2,22-4.3,29.6-6.2 c2.5,12.6,5.3,27.8,8,45.1c0.2,1.5,0.5,3,0.7,4.6c2.8,18.2,5.5,38.6,7.7,60.8c1.6,16.7,2.9,32.7,3.8,48.3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st391",
    d: "M241.5,206.4v102.1c-1.4,14.1-13.3,24.8-27.4,24.8c-0.9,0-1.8-0.1-2.7-0.2c-0.1-37.2-0.2-74.5-0.4-111.7V221 c0-5,0-10-0.1-14.9V206h1.2c2.6,0.1,5.1,0.1,7.3,0.1C226.4,206.3,233.7,206.5,241.5,206.4z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st390",
    d: "M241.5,206.4v102.1c-1.4,14.1-13.3,24.8-27.4,24.8c-0.9,0-1.8-0.1-2.7-0.2l-0.5,0v-127h1.2 c2.6,0.1,5.1,0.1,7.3,0.1C226.4,206.3,233.7,206.5,241.5,206.4z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st389",
    d: "M214.1,331.8c-0.5,0-1.1,0-1.6-0.1V207.6c2.5,0.1,4.8,0.1,7,0.1c6.3,0.1,12.5,0.2,19,0.2h1.6v100.5 C238.8,321.8,227.5,332,214.1,331.8z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st388",
    d: "M212.1,206.1h-1.2V206h0.1L212.1,206.1z"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "st387",
    x1: 293.4,
    y1: 203.7,
    x2: 359,
    y2: 310.3
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "st386",
    x1: 289.3,
    y1: 202.8,
    x2: 361.2,
    y2: 319.6
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "st385",
    x1: 289.3,
    y1: 202.8,
    x2: 289.7,
    y2: 203.4
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "st384",
    x1: 290.5,
    y1: 204.8,
    x2: 360.4,
    y2: 318.3
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "st385",
    x1: 360.8,
    y1: 318.9,
    x2: 361.2,
    y2: 319.6
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "st386",
    x1: 137,
    y1: 201.2,
    x2: 62,
    y2: 316.8
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    className: "st385",
    x1: 137,
    y1: 201.2,
    x2: 136.6,
    y2: 201.9
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    className: "st384",
    x1: 135.7,
    y1: 203.2,
    x2: 62.9,
    y2: 315.4
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    className: "st385",
    x1: 62.5,
    y1: 316.1,
    x2: 62,
    y2: 316.8
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    className: "st387",
    x1: 131.2,
    y1: 203.5,
    x2: 62.8,
    y2: 310.3
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st383",
    d: "M147.8,178.4c33.3,3.4,65.1,0.1,95.1-0.8c0.2,9,0.4,17.9,0.6,26.9c-15.3,1-28.2,1.3-37.7,1.4 c-25,0.4-55.6,0.7-92.9-4.9c-14-2.1-25.6-4.5-33.5-6.4c2.6-8.2,5.1-16.3,7.6-24.5L147.8,178.4z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st382",
    d: "M286.9,176.7c-27,3.6-52.8,0.1-77-0.8c-1.3,9.2-1.5,18.5-0.5,27.8c12.4,1,22.8,1.4,30.5,1.5 c20.3,0.4,45,0.7,75.2-5c11.4-2.2,20.8-4.7,27.1-6.6c-2.1-8.5-4.2-16.8-6.2-25.3L286.9,176.7z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st381",
    points: "144.1,172.7 144,175 143.6,197.5 143.4,206.3 143.2,215.2 132.4,214.9 132.6,205.2 132.8,196.7  133.3,173.3 133.3,172.4 "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st381",
    points: "291.9,214 281.1,214.3 280.9,205.4 280.7,196 280.3,173.9 280.2,171.7 291,171.4 291,172.2  291.5,195.1 291.7,204.2 "
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 227.3,
    cy: 189.5,
    r: 7.1
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 218.8,
    y: 188.5,
    width: 18.7,
    height: 2.1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCutbelt);
export default __webpack_public_path__ + "static/media/CUT BELT.dca8d33b11c8baa3e6f06555dba9906c.svg";
export { ForwardRef as ReactComponent };